import React from "react";
import Layout from "@/components/Layout";
import AgencyDirectory from "@/components/AgencyDirectory";

export default function Directory() {
  return (
    <Layout>
      <div className="flex-1 overflow-hidden" data-testid="directory-page">
        <AgencyDirectory />
      </div>
    </Layout>
  );
}
